import { html, on, rune, View } from 'rune-ts';
import klass from './PopupStoreSection.module.scss';
import { PopupStoreItemCardType } from '../../../../../features/PopupStores/type';
import { ButtonAction } from '../../../../../shared/components/atoms/ButtonAction/ButtonAction';
import { map, pipe, toArray } from '@fxts/core';
import { PopupStoreCard } from './PopupStoreCard';
import { typoPcMo } from '../../../../../shared/typography/typo';
import Swiper from 'swiper';
import { Pagination } from 'swiper/modules';
import { htmlIf } from '../../../../../shared/util';
import { PopupStoreIcon } from '../../../../components/atoms/Icon';
import { MShopUtilF } from '../../../../../../../modules/MShop/Util/F/Function/module/MShopUtilF';
import { mpsPostMessage } from '../../../../../shared/app/util';
import { makeEmptyScreenNavigate } from '../../../../../shared/app/navigate';

interface PopupStoreSectionProps {
  popup_stores: PopupStoreItemCardType[];
}

export class PopupStoreSection extends View<PopupStoreSectionProps> {
  swiper?: Swiper;
  popupStoreCards: PopupStoreCard[] = this._createPopupStoreCards();

  override template() {
    const is_mobile = !!rune.getSharedData(this)?.is_mobile;

    return html`
      <section class="${klass.popup_store}">
        <div class="${klass.title} ${typoPcMo({ is_mobile, pc: '48_bold', mo: '28_bold' })}">
          ${html.preventEscape(ET('mps2::landing::popup_store::popup_store_title'))}
        </div>
        <!--   pc   -->
        ${htmlIf(html` <div class="${klass.content}">${this.popupStoreCards}</div> `, !is_mobile)}

        <!--   mobile   -->
        ${htmlIf(
          html` <div class="${klass.swiper} swiper popup_store_swiper">
            <div class="${klass.swiper_wrapper} swiper-wrapper ">
              ${this.popupStoreCards.map(
                (card) => html`<div class="swiper-slide ${klass.slide}">${card}</div>`,
              )}
            </div>
            <div class="${klass.pagination} swiper-pagination"></div>
          </div>`,
          is_mobile,
        )}
        ${new ButtonAction({
          type: 'white',
          label: html`<div class="${klass.button_label}">
            ${htmlIf(PopupStoreIcon, !is_mobile)} ${ET('mps2::landing::popup_store::popup_store_button')}
          </div> `,
          klass: klass.more,
          size: is_mobile ? 'medium' : 'large',
        })}
      </section>
    `;
  }

  private _createPopupStoreCards() {
    const { popup_stores } = this.data;

    return pipe(
      popup_stores,
      map((popup_store) => new PopupStoreCard({ popup_store })),
      toArray,
    );
  }

  override onRender() {
    const is_mobile = !!rune.getSharedData(this)?.is_mobile;

    if (is_mobile) {
      this.swiper = this._onLoadPopupStoreSwiper();
    }
  }

  private _onLoadPopupStoreSwiper() {
    return new Swiper('.popup_store_swiper', {
      modules: [Pagination],
      slidesPerView: 'auto',
      spaceBetween: 16,
      pagination: {
        el: '.swiper-pagination',
        type: 'progressbar',
        progressbarFillClass: `${klass.progressbar_fill} swiper-pagination-progressbar-fill`,
      },
      on: {
        touchStart: function (_, event) {
          event.stopPropagation();
        },
        touchMove: function (_, event) {
          event.stopPropagation();
        },
        init: function (swiper) {
          swiper.el.classList.add(klass.visible);
        },
      },
    });
  }

  @on('click', `.${klass.more}`)
  clickMoreButton() {
    if (MShopUtilF.isApp()) {
      mpsPostMessage(makeEmptyScreenNavigate(`/${ET.lang}/@/popup-store?bottom_tab_display=hidden`));
    } else {
      window.location.href = `/${ET.lang}/@/popup-store`;
    }
  }
}
